function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import clsx from 'clsx';
import { drawerContentStyles } from "../../common";
var PREFIX = 'BrandDrawerContent';
var classes = {
  closeButton: "".concat(PREFIX, "-closeButton"),
  closeIcon: "".concat(PREFIX, "-closeIcon"),
  fullList: "".concat(PREFIX, "-fullList")
};
var Root = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty(_defineProperty(_defineProperty({}, "& .".concat(classes.closeButton), {
    position: 'absolute',
    top: '10px',
    right: 0
  }), "& .".concat(classes.closeIcon), {
    color: theme.palette.font.primary
  }), "&.".concat(classes.fullList), drawerContentStyles(theme));
});
var BrandDrawerContent = function BrandDrawerContent(_ref3) {
  var children = _ref3.children,
    toggleDrawer = _ref3.toggleDrawer,
    onClose = _ref3.onClose,
    className = _ref3.className;
  return /*#__PURE__*/React.createElement(Root, {
    className: clsx(classes.fullList, _defineProperty({}, className, !!className)),
    role: "presentation",
    onClick: toggleDrawer,
    onKeyDown: toggleDrawer
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.closeButton,
    onClick: onClose,
    size: "large"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: classes.closeIcon
  })), children);
};
BrandDrawerContent.propTypes = {
  children: PropTypes.any,
  toggleDrawer: PropTypes.func,
  className: PropTypes.string
};
export default BrandDrawerContent;